import { CustomType, UserCustomDailyProgress } from '../../services/api.types'
import { t } from 'ttag'
import dayjs from '../../dayjsConfig'
import { formatThousands } from '../../common/helpers/translations'
import * as React from 'react'
import { Fragment, useState } from 'react'
import './YumCustomTable.scss'
import { getLongDateString } from '../../common/helpers/date'
import { PointsLogic } from '../../views/ChallengeAdmin/components/ChallengePoints/ChallengePoints'
import { CustomTypeCategory, getCustomUnitText, getPointsTypeText } from '../../services/CustomTypes'
import { AllCustomProgress, AllDailyDiary } from '../YumCustomEntry/YumCustomEntry'
import { unitsCountPointsShortFunc } from '../../common/helpers/units'
import { ReactComponent as ExpandIcon } from '../../assets/v3/icons/expand.svg'
import { YumActivityIcon } from '../YumActivityIcon/YumActivityIcon'
import { List } from '@material-ui/core'
import { dailyMaxLabel, totalMaxLabel, useStyles } from '../../views/ChallengeInfo/ChallengeInfo'
import { getListItems, renderPointsActivity } from '../../views/ChallengeInfo/ChallengeInfo.legacy'

import { isAutomatedType, isSimpleDayType } from '../../common/helpers/challenges'

import { ReactComponent as DoneIcon } from '../../assets/v3/icons/done.svg'
import { ReactComponent as NotDoneIcon } from '../../assets/v3/icons/not-done.svg'

export interface IStateProps {
  data: UserCustomDailyProgress[]
  valueGoal: number
  unitsLabel: string
  units?: string
  binary: boolean
  showDigits?: boolean
  pointsLogic?: PointsLogic[]
  allDailyDiary?: AllDailyDiary
  allCustomProgress?: AllCustomProgress
  manualEntryEnabled: boolean
  roundDailyPoints: boolean
  oldRoundDailyPoints: boolean
  dailyMax?: number | null
}

export default function YumCustomTable(props: IStateProps) {
  const {
    data,
    valueGoal,
    unitsLabel,
    units,
    binary,
    pointsLogic,
    allDailyDiary,
    allCustomProgress,
    manualEntryEnabled,
    roundDailyPoints,
    oldRoundDailyPoints,
    dailyMax,
  } = props
  const classes = useStyles()
  // console.log('allCustomProgress', allCustomProgress)

  const [openDays, setOpenDays] = useState([] as string[])

  const showDigits = pointsLogic ? !roundDailyPoints : props.showDigits

  const showDetails = (date: string) => {
    const index = openDays.indexOf(date)
    const isOpen = index > -1
    if (isOpen) {
      setOpenDays(openDays.filter((_, i) => i !== index))
    } else {
      setOpenDays([...openDays, date])
    }
  }

  const valueBEM = (met: boolean) => {
    const base = 'data-item__value'
    const classArray = [base]
    if (met) {
      classArray.push(`${base}--met`)
    }
    return classArray.join(' ')
  }

  const getPointsValue = (activity: PointsLogic, date: string) => {
    if (activity.unit === CustomType.CUSTOM) {
      const day = allCustomProgress?.[activity.id]?.find((d: { date: string }) => d.date === date)
      return day?.value || 0
    } else {
      const day = allDailyDiary?.[activity.unit]?.find((d) => d.date === date)
      if (!day) return 0
      return (manualEntryEnabled || !isAutomatedType(activity.unit) ? day.sum : day.integrationValue) || 0
    }
  }

  const getPointsPoints = (activity: PointsLogic, sum: number) => {
    // Calculate points.
    let points = sum > 0 ? (sum / activity.value) * activity.points : 0
    if (!oldRoundDailyPoints && roundDailyPoints && sum > 0) {
      const intervals = Math.floor(sum / activity.value)
      points = intervals * activity.points
    }

    // Max daily points check. Cap if needed.
    if (activity.category !== CustomTypeCategory.CUSTOM_SIMPLE) {
      if (activity.dailyGoal && !isSimpleDayType(activity.category) && activity.dailyGoal > 0) {
        const maxDailyPoints = (activity.dailyGoal / activity.value) * activity.points
        if (points > maxDailyPoints) {
          points = maxDailyPoints
        }
      }
    }

    return roundDailyPoints ? Math.floor(points) : points
  }

  const getPointsUnit = (activity: PointsLogic) =>
    activity.category === CustomTypeCategory.CUSTOM_SIMPLE
      ? t`Done`.toLowerCase()
      : getCustomUnitText(activity.unit, activity.unit, activity.customUnitName)

  const getPointsDayData = (allCustomProgress: any, date: string, id: string) => {
    return allCustomProgress['default']
      .find((d: { date: string }) => d.date === date)
      .data.find((d: { id: string }) => d.id === id)
  }

  const getPointsData = (pointsLogic: PointsLogic[], date: string, allCustomProgress: any) => {
    return pointsLogic
      .filter((activity) => getPointsValue(activity, date) > 0)
      .map((activity) => {
        //console.log('activity', activity)
        const dayValue = getPointsValue(activity, date)
        const dayData = getPointsDayData(allCustomProgress, date, activity.id)
        console.log('dayData', dayData)
        return {
          ...activity,
          dayValue,
          dayPoints: getPointsPoints(activity, dayValue),
          dayData,
        }
      })
      .map(renderPointsActivity(roundDailyPoints, true))
    /*.map((activity) => {
        const value = getPointsValue(activity, date)
        const formattedValue = formatThousands(value)
        const unit = getPointsUnit(activity)
        const points = getPointsPoints(activity, value)
        const pointsAmount = formatThousands(points, roundDailyPoints ? 0 : 2)
        const pointsUnit = unitsCountPointsShortFunc(points)
        return {
          label: getPointsTypeText(activity),
          content: `${formattedValue} ${unit} = ${pointsAmount} ${pointsUnit}`,
          /!*content: (
            <>
              <div>{`${formattedValue} ${unit} = ${pointsAmount} ${pointsUnit}`}</div>
              {showDailyMax ? (
                <div style={{ opacity: 0.7, fontSize: '11px' }}>
                  {`${dailyMaxLabel}: ${formatThousands(dailyMax)} ${maxPointsUnit}`}
                </div>
              ) : null}
              {showTotalMax ? (
                <div style={{ opacity: 0.7, fontSize: '11px' }}>
                  {`${totalMaxLabel}: ${formatThousands(totalMax)} ${totalMaxUnit}`}
                </div>
              ) : null}
              {isBonusPoints ? <div style={{ opacity: 0.7, fontSize: '11px' }}>{t`Bonus points`}</div> : null}
            </>
          ),*!/
          Icon: (
            <YumActivityIcon
              category={activity.icon || activity.category}
              color={'darkBlue'}
              isInactive={true}
              extraPadding={true}
            />
          ),
        }
      })*/
  }

  const today = new Date()
  return (
    <table className="custom-table custom-table__me">
      <thead>
        <tr>
          <th>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.4 4.8C6.4 3.91875 7.11563 3.2 8 3.2C8.88438 3.2 9.6 3.91875 9.6 4.8V6.4H11.2C12.0844 6.4 12.8 7.11875 12.8 8C12.8 8.88125 12.0844 9.6 11.2 9.6H8C7.11563 9.6 6.4 8.88125 6.4 8V4.8Z"
                fill="#006FFF"
              />
            </svg>
            {t`Date`}
          </th>
          <th className={'data-item__value'}>{!binary ? unitsLabel : t`Done`}</th>
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map(({ date, value }, keyIndex) => {
            const isOpen = openDays.includes(date)
            const allowOpening = !!(pointsLogic && value > 0)
            return (
              dayjs(date).isBefore(today) && (
                <Fragment key={keyIndex}>
                  <tr
                    style={allowOpening ? { cursor: 'pointer', userSelect: 'none' } : {}}
                    onClick={() => allowOpening && showDetails(date)}
                  >
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {pointsLogic && (
                          <div style={{ width: 40 }}>
                            <ExpandIcon
                              style={{
                                transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                opacity: allowOpening ? 1 : 0.5,
                              }}
                            />
                          </div>
                        )}
                        <div>
                          <div className={'data-item__day'}>{dayjs(date).format('dddd')}</div>
                          <div className={'data-item__date'}>{getLongDateString(dayjs(date).toDate())}</div>
                        </div>
                      </div>
                    </td>
                    <td className={valueBEM(value >= valueGoal)}>
                      {!binary ? (
                        <>
                          {formatThousands(value, showDigits ? 2 : undefined)}
                          {units}
                          {dailyMax && value > dailyMax ? (
                            <div>
                              <small>
                                {t`Daily limit per user`}: {formatThousands(dailyMax)}
                              </small>
                            </div>
                          ) : null}
                        </>
                      ) : (
                        <>{value >= valueGoal ? <DoneIcon /> : <NotDoneIcon />}</>
                      )}
                    </td>
                  </tr>

                  {pointsLogic && isOpen && (
                    <tr>
                      <td colSpan={2}>
                        <List style={{ marginLeft: '40px' }}>
                          {getPointsData(pointsLogic, date, allCustomProgress).map(getListItems(classes, true))}
                        </List>
                      </td>
                    </tr>
                  )}
                </Fragment>
              )
            )
          })}
      </tbody>
    </table>
  )
}
